import type { OrderDetailsExtended } from 'app/src/model'
import type { moneytransferApi } from 'app/src/services/welfareportal'
import type { Membership } from 'app/src/services/welfareportal/membership-api/membership-schemas'
import type { RelativeResponse } from 'app/src/services/welfareportal/moneytransfer-api'

export const createNewTransfer = (
  order: OrderDetailsExtended,
  membershipData: Membership,
): moneytransferApi.TransferResponseWithUserInfo => {
  return {
    id: order?.orderId,
    familyMembers: (membershipData?.userFamilyMembers as RelativeResponse[]) || [],
    detailUrl: order?.detailPageUrl,
    date: order?.orderDate,
    productName: order?.product?.productName,
    productCode: order?.product?.productId,
    beneficiaryId: membershipData?.userId,
    kind: order?.product?.externalId === 'moneyTransfer|FONDO_SANITARIO' ? 'FONDO_SANITARIO' : 'PREVIDENZA_COMPLEMENTARE',
    status: {
      value: 'DRAFT',
      updatedAt: order?.orderDate,
    },
    amount: order?.priceDetails?.grossPrice || 0,
    orderId: order?.orderId,
    isCancellable: false,
    userInfo: {
      firstName: membershipData?.userFirstName || '',
      lastName: membershipData?.userLastName || '',
      email: membershipData?.userEmail || '',
      fiscalCode: membershipData?.userFiscalCode || '',
    },
  }
}
